// extracted by mini-css-extract-plugin
module.exports = {"container":"KanbanBoardWrapper_container__30s7y","title":"KanbanBoardWrapper_title__NqRCw"};